import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Header from './Header';
import Home from './Home';
import Login from './Login';
import { useStateValue } from './store/stateProvider';
import { auth } from './config/firebase';
import Checkout from './Checkout';
import Pay from './Pay';
import Orders from './Orders';

// const promise = loadStripe(process.env.REACT_APP_PUBLIC_KEY_STRIPE);
const promise = loadStripe(
  'pk_test_51HoBomAn3GxLKzlbvhXwhxM1gnvAnkqvVLXawU8xVnNR9dhlK8GofmpUVmO3heCJYgvzyJm95Aq6jesrGzJv5Cyu00ylrnJSLP'
);

function App() {
  const [, dispatch] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser
        });
      } else {
        dispatch({
          type: 'SET_USER',
          user: null
        });
      }
    });
  }, []);
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>
          <Route path="/orders">
            <Header />
            <Orders />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Pay />
            </Elements>
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route exact path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
